import { createEvent } from 'effector'

import { NodeLayoutOptions } from '@flowx/designer/modules/core/dictionary/process.dictionary'
import { SwimlaneSummary } from '@flowx/designer/modules/core/dictionary/swimlane.dictionary'
import type { AreaSummary, PasteAreasPayload } from '@flowx/designer/shared/api/area.api'
import { NavigationFlow } from '@flowx/designer/shared/api/navigation-flow.api'
import type {
  Area,
  AreaPlatform,
  NewAreaPayload,
  ParentProcessAreaRemovePayload,
  ReorderAreas,
} from '@flowx/designer/shared/entities/nav-area.entity'

export class AreasEvents {
  static readonly createArea = createEvent<Partial<NewAreaPayload>>('createArea')
  static readonly createParentProcessArea =
    createEvent<Partial<NewAreaPayload>>('createParentProcessArea')
  static readonly removeArea = createEvent<Area>('removeArea')
  static readonly removeParentProcessArea =
    createEvent<ParentProcessAreaRemovePayload>('removeParentProcessArea')
  static readonly updateAreaSubprocesses = createEvent<{
    subprocesses: {
      applicationId: string
      resourceDefinitionId: string
    }[]
    areaId: number
    swimlaneDefinitionId: SwimlaneSummary['id']
  }>('updateAreaSubprocesses')
  static readonly openSettings = createEvent<Area>('openSettings')
  static readonly updateAreaSettings = createEvent<Partial<Area>>('updateAreaSettings')
  static readonly reorderAreas = createEvent<ReorderAreas>('reorderAreas')
  static readonly areaClicked = createEvent<AreaSummary | null>('areaClicked')
  static readonly areaSelectedOnCanvas = createEvent<AreaSummary | null>('areaSelected')
  /**
   * Area clicked on a canvas that measures its own coordinates; drives the floating
   * actions menu.
   */
  static readonly areaLeftClickOnCanvas = createEvent<{
    entity: AreaSummary
    viewportCoords: { x: number; y: number; width: number; height: number }
  }>('areaLeftClickOnCanvas')
  static readonly platformSelected = createEvent<AreaPlatform>('platformSelected')
  static readonly resizeArea = createEvent<{
    areaId: Area['id']
    swimlaneDefinitionId: SwimlaneSummary['id']
    layoutOptions: NodeLayoutOptions
  }>('resizeArea')
  static readonly filterByNavigationFlows = createEvent<{
    swimlaneId: SwimlaneSummary['id']
    navigationFlowIds: NavigationFlow['id'][]
  }>('filterByNavigationFlows')

  static readonly pasteAreas = createEvent<PasteAreasPayload>('pasteAreas')
  static readonly toggleSubprocessesVisibility = createEvent<{
    swimlaneId: SwimlaneSummary['id']
    areaId: Area['id']
  }>('showSubprocesses')
  static readonly cleanupAreas = createEvent('cleanupAreas')
  static readonly resetSelectedPlatform = createEvent('resetSelectedPlatform')
  static readonly navigateToUIDesigner = createEvent<AreaSummary>('navigateToUIDesigner')
}
